import { combineReducers } from "redux";

import base from "./baseReducers";
export default combineReducers({
  //reducer name here
  base
});
